// body loaded
window.addEventListener("load", function() {
    document.querySelector("body").classList.add("loaded");
});




$(document).ready(function() {



    var galleryTop = new Swiper('.gallery-top', {
        slidesPerView: 6,
        spaceBetween: 10,
        loop: true,
        // loopedSlides: 4
        slideToClickedSlide: true,
    });
    var galleryThumbs = new Swiper('.gallery-thumbs', {
        spaceBetween: 10,
        centeredSlides: true,
        slidesPerView: 'auto',
        touchRatio: 0.2,
        slideToClickedSlide: true,
        loop: true,
        // loopedSlides: 4
        navigation: {
            nextEl: ' .mentor-prev',
            prevEl: '.mentor-next',
        },
    });
    galleryTop.controller.control = galleryThumbs;
    galleryThumbs.controller.control = galleryTop;





})

var aboutswiper = new Swiper(".aboutSwiper", {
    slidesPerView: 1,
    autoplay: {
        delay: 2000,
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});